import React, { memo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./ImageTemplate.css";
import ImageRenderer from "./ImageRenderer";
import { templates } from "./templateContants";
// Generate an array of react components that will be rendered as image thumbails for
// the user to download!

const ImageTemplate = ({ details, setIsLoadingImage, setShareGeneratedElements, scale, idName, imageUrls }) => {
  const [elements, setElements] = useState([]);

  useEffect(() => {
    if (!details) return;
    let cta;
    if(details.giveorreceive === "give"){
      cta = "Let me make your day. Accept anonymously."
    } else if (details.giveorreceive === "receive"){
      cta = "Make my day, anonymously."
    }

    // Create an array of React components, one for each class template
    const generatedElements = templates.map((template, index) => (
      <ImageRenderer 
        key={`${template}-${index}-${scale}`} 
        details={details} 
        cta={cta} 
        templateIndex={index} 
        scale={scale}
        imageUrls={imageUrls}
      />
    ));

    // #shareImageTemplate is used within the sharePostModal, to render the image options
    if(idName === "shareImageTemplate"){
      setShareGeneratedElements(generatedElements);
      setElements(generatedElements);
      setIsLoadingImage(false);
    } else if(idName === "downloadImageTemplate") {
      // setGeneratedElements(generatedElements);
      setElements(generatedElements);
    }
  }, [details])
  
  return <div id={idName} className='image-template-container'>{elements}</div>;
};

ImageTemplate.propTypes = {
  setIsLoadingImage: PropTypes.func,
  // setGeneratedElements: PropTypes.func,
  setShareGeneratedElements: PropTypes.func,
  templateIndex: PropTypes.number,
  scale: PropTypes.number,
  idName: PropTypes.string,
  imageUrls: PropTypes.object,
  details: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string,
    amount: PropTypes.number,
    giveorreceive: PropTypes.string,
    remainingQuantity: PropTypes.number,
    initialQuantity: PropTypes.number,
    photo: PropTypes.string,
    wishlistItems: PropTypes.array,
    username: PropTypes.string
  }),
}

  // Use memo to prevent unnecessary re-renders if props haven't changed
export default memo(ImageTemplate, (prevProps, nextProps) => {
  // Custom comparison function to determine if the component should re-render
  return prevProps.details === nextProps.details &&
         prevProps.idName === nextProps.idName &&
         prevProps.imageUrls === nextProps.imageUrls &&
         prevProps.scale === nextProps.scale;
});